export const ALLIANCE_GROUP_SUBTITLE = 'Alliance Group';
export const FIVE_RINGS_FINANCIAL_SUBTITLE = 'Five Rings Financial';
export const LIVING_BENEFIT_SOLUTIONS_SUBTITLE = 'Living Benefit Solutions';
